import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

const swiper = new Swiper('.infosSwiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
	loop: true,
	effect: "fade",
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".swiper-infos-next",
        prevEl: ".swiper-infos-prev",
    },
});